// import React, { useState, useEffect } from 'react';
// import { Container, Row, Col, Card, Form } from 'react-bootstrap';
// import {
//   BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
//   Legend
// } from 'recharts';
// import axios from '../api/axios';

// // Reusable KPI card component
// // const KpiCard = ({ title, value, valueColor }) => (
// //   <Card
// //     className="text-center shadow-sm"
// //     style={{
// //       backgroundColor: '#fff',
// //       border: 'none',
// //       borderRadius: '10px',
// //       transition: 'transform 0.3s, box-shadow 0.3s',
// //     }}
// //     onMouseEnter={(e) => {
// //       e.currentTarget.style.transform = 'scale(1.03)';
// //       e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
// //     }}
// //     onMouseLeave={(e) => {
// //       e.currentTarget.style.transform = 'scale(1)';
// //       e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
// //     }}
// //   >
// //     <Card.Body>
// //       <Card.Title style={{ fontSize: '1.25rem', fontWeight: '600', color: '#343a40' }}>
// //         {title}
// //       </Card.Title>
// //       <Card.Text as="h4" style={{ fontSize: '2rem', color: valueColor }}>
// //         {value}
// //       </Card.Text>
// //     </Card.Body>
// //   </Card>
// // );

// const KpiCard = ({ title, value, valueColor, icon, backgroundColor }) => (
//   <Card className="h-100 shadow-sm border-0 transition-all">
//     <Card.Body
//       className="d-flex flex-column justify-content-between p-3"
//       style={{ backgroundColor }}
//     >
//       <div>
//         {/* Title */}
//         <Card.Title className="text-muted mb-2" style={{ fontSize: '0.9rem', fontWeight: '500' }}>
//           {title}
//         </Card.Title>
//         {/* Value */}
//         <Card.Text as="h4" style={{ color: valueColor, fontWeight: '600' }}>
//           {value}
//         </Card.Text>
//       </div>
//       {/* Icon */}
//       <div className="text-end">
//         <i className={`bi ${icon} fs-3`} style={{ color: valueColor }}></i>
//       </div>
//     </Card.Body>
//   </Card>
// );

// const UsersKPI = () => {
//   const token = localStorage.getItem('authToken');
//   const [totalUsersData, setTotalUsersData] = useState({});
//   const [cityWiseUsers, setCityWiseUsers] = useState([]);
//   const [repeatingUsersTrend, setRepeatingUsersTrend] = useState([]);
//   const [outletFilter, setOutletFilter] = useState('all');
//   const [userTypeFilter, setUserTypeFilter] = useState('all');
//   const [timeFilter, setTimeFilter] = useState('weekly');
//   const [outlets, setOutlets] = useState([]);

//   const fetchGraphData = async () => {
//     try {
//       let url = 'dashboard/getUsersDataStats';
//       let params = [];
//       if (outletFilter !== 'all') {
//         params.push(`outletId=${outletFilter}`);
//       }
//       if (timeFilter === 'weekly') {
//         params.push("weekly=true");
//       } else if (timeFilter === 'monthly') {
//         params.push("monthly=true");
//       }
//       if (params.length > 0) {
//         url += `?${params.join('&')}`;
//       }
//       const response = await axios.get(url, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       if (response?.data?.data) {
//         const data = response.data.data;
//         const barChartData = [
//           {
//             city: 'Total',
//             appUsers: data.totalNumberOfAppUsers?.[0]?.count || 0,
//             kioskUsers: data.totalNumberOfKioskUsers?.[0]?.count || 0,
//             deletedUsers: data.totalNumberOfDeletedUsers?.[0]?.count || 0,
//             repeatingUsers: data.totalRepeatingUsers?.[0]?.count || 0,
//             referralUsers: data.totalReferredUsers?.[0]?.count || 0,
//             usersWithoutOrders: data.totalUsersWithoutOrders?.[0]?.count || 0,
//           },
//         ];
//         setCityWiseUsers(barChartData);

//         // Simulate trend data for repeating users (replace with real API data as needed)
//         const trendData = [
//           {
//             date: new Date().toLocaleDateString(),
//             repeatingUsers: data.totalRepeatingUsers?.[0]?.count || 0,
//           },
//         ];
//         setRepeatingUsersTrend(trendData);
//       }
//     } catch (error) {
//       console.error('Error fetching graph data:', error);
//     }
//   };

//   const fetchTotalUsersKPIData = async () => {
//     try {
//       const url = 'dashboard/getUsersDataStats';
//       const response = await axios.get(url, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       if (response?.data?.data) {
//         setTotalUsersData(response.data.data);
//       }
//     } catch (error) {
//       console.error('Error fetching total users data:', error);
//     }
//   };

//   const getOutlets = async () => {
//     try {
//       const headers = { Authorization: `Bearer ${token}` };
//       const response = await axios.get('outlet', { headers });
//       if (response?.data?.status === true) {
//         setOutlets(response?.data?.data?.outlets);
//       }
//     } catch (error) {
//       console.error('Error fetching outlets:', error);
//     }
//   };

//   useEffect(() => {
//     fetchTotalUsersKPIData();
//     getOutlets();
//     fetchGraphData();
//   }, []);

//   useEffect(() => {
//     fetchGraphData();
//   }, [timeFilter, outletFilter]);

//   return (
//     <Container fluid className="py-4 shadow-sm" style={{ backgroundColor: 'white' }}>
//       <h2 className="mb-4 fw-bold">USER ANALYTICS</h2>
//       <hr />
//       {/* Overall Users Data Section */}
//       <Card className="mb-4 shadow-sm">
//         <Card.Header as="h5" className="bg-primary text-white">
//           Overall Users Data
//         </Card.Header>
//         <Card.Body>
//         <Row className="g-4 justify-content-center">
//           {/* Total App Users */}
//           <Col md={3} sm={6}>
//             <KpiCard
//               title="Total App Users"
//               value={totalUsersData?.totalNumberOfAppUsers?.[0]?.count || 0}
//               valueColor="#007bff"
//               icon="bi-phone"
//               backgroundColor="rgba(0, 123, 255, 0.1)"
//             />
//           </Col>

//           {/* Total Kiosk Users */}
//           <Col md={3} sm={6}>
//             <KpiCard
//               title="Total Kiosk Users"
//               value={totalUsersData?.totalNumberOfKioskUsers?.[0]?.count || 0}
//               valueColor="#28a745"
//               icon="bi-display"
//               backgroundColor="rgba(40, 167, 69, 0.1)"
//             />
//           </Col>

//           {/* Total Deleted Users */}
//           <Col md={3} sm={6}>
//             <KpiCard
//               title="Total Deleted Users"
//               value={totalUsersData?.totalNumberOfDeletedUsers?.[0]?.count || 0}
//               valueColor="#dc3545"
//               icon="bi-trash"
//               backgroundColor="rgba(220, 53, 69, 0.1)"
//             />
//           </Col>

//           {/* Total Referred Users */}
//           <Col md={3} sm={6}>
//             <KpiCard
//               title="Total Referred Users"
//               value={totalUsersData?.totalReferredUsers?.[0]?.count || 0}
//               valueColor="#6f42c1"
//               icon="bi-people"
//               backgroundColor="rgba(111, 66, 193, 0.1)"
//             />
//           </Col>

//           {/* Total Repeating Users */}
//           <Col md={3} sm={6}>
//             <KpiCard
//               title="Total Repeating Users"
//               value={totalUsersData?.totalRepeatingUsers?.[0]?.count || 0}
//               valueColor="#fd7e14"
//               icon="bi-arrow-repeat"
//               backgroundColor="rgba(253, 126, 20, 0.1)"
//             />
//           </Col>

//           {/* Total Users Without Orders */}
//           <Col md={3} sm={6}>
//             <KpiCard
//               title="Total Users Without Orders"
//               value={totalUsersData?.totalUsersWithoutOrders?.[0]?.count || 0}
//               valueColor="#17a2b8"
//               icon="bi-cart-x"
//               backgroundColor="rgba(23, 162, 184, 0.1)"
//             />
//           </Col>
//         </Row>
//         </Card.Body>
//       </Card>

//       {/* Weekly/Monthly Users Data Section */}
//       <Card className="shadow-sm">
//         <Card.Header as="h5" className="bg-secondary text-white">
//           {timeFilter === 'weekly' ? 'Weekly Users Data' : 'Monthly Users Data'}
//         </Card.Header>
//         <Card.Body>
//           <Row className="mb-4">
//             <Col md={4}>
//               <Form.Group>
//                 <Form.Label>Outlet</Form.Label>
//                 <Form.Select
//                   value={outletFilter}
//                   onChange={(e) => setOutletFilter(e.target.value)}
//                 >
//                   <option value="all">All</option>
//                   {outlets
//                     .filter((outlet) => outlet?.status === 'ACTIVE')
//                     .map((outlet) => (
//                       <option key={outlet?._id} value={outlet?._id}>
//                         {outlet?.name}
//                       </option>
//                     ))}
//                 </Form.Select>
//               </Form.Group>
//             </Col>
//             <Col md={4}>
//               <Form.Group>
//                 <Form.Label>Duration</Form.Label>
//                 <Form.Select
//                   value={timeFilter}
//                   onChange={(e) => setTimeFilter(e.target.value)}
//                 >
//                   <option value="weekly">Weekly</option>
//                   <option value="monthly">Monthly</option>
//                 </Form.Select>
//               </Form.Group>
//             </Col>
//           </Row>
//           <Row>
//             <Col md={12}>
//               <h5 className="mb-3">Users Type</h5>
//               <ResponsiveContainer width="100%" height={300}>
//                 <BarChart data={cityWiseUsers}>
//                   <CartesianGrid strokeDasharray="3 3" />
//                   <XAxis dataKey="city" />
//                   <YAxis />
//                   <Tooltip />
//                   <Legend wrapperStyle={{ marginLeft: 20 }} />
//                   <Bar dataKey="appUsers" fill="#8884d8" name="App" />
//                   <Bar dataKey="kioskUsers" fill="#82ca9d" name="Kiosk" />
//                   <Bar dataKey="deletedUsers" fill="#ffc658" name="Deleted" />
//                   <Bar dataKey="repeatingUsers" fill="#ff7300" name="Repeating" />
//                   <Bar dataKey="referralUsers" fill="#d27300" name="Referred" />
//                   <Bar dataKey="usersWithoutOrders" fill="#d62728" name="Without Orders" />
//                 </BarChart>
//               </ResponsiveContainer>
//             </Col>
//           </Row>
//         </Card.Body>
//       </Card>
//     </Container>
//   );
// };

// export default UsersKPI;


import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Form, Spinner } from 'react-bootstrap';
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
  Legend
} from 'recharts';
import axios from '../api/axios';

const KpiCard = ({ title, value, valueColor, icon, backgroundColor, loading }) => (
  <Card className="h-100 shadow-sm border-0 transition-all">
    <Card.Body
      className="d-flex flex-column justify-content-between p-3"
      style={{ backgroundColor }}
    >
      <div>
        {/* Title */}
        <Card.Title className="text-muted mb-2" style={{ fontSize: '0.9rem', fontWeight: '500' }}>
          {title}
        </Card.Title>
        {/* Value */}
        {loading ? (
          <div className="d-flex justify-content-center align-items-center" style={{ height: '40px' }}>
            <Spinner animation="border" size="sm" variant={valueColor} />
          </div>
        ) : (
          <Card.Text as="h4" style={{ color: valueColor, fontWeight: '600' }}>
            {value}
          </Card.Text>
        )}
      </div>
      {/* Icon */}
      <div className="text-end">
        <i className={`bi ${icon} fs-3`} style={{ color: valueColor }}></i>
      </div>
    </Card.Body>
  </Card>
);

const UsersKPI = () => {
  const token = localStorage.getItem('authToken');
  const [totalUsersData, setTotalUsersData] = useState({});
  const [cityWiseUsers, setCityWiseUsers] = useState([]);
  const [repeatingUsersTrend, setRepeatingUsersTrend] = useState([]);
  const [outletFilter, setOutletFilter] = useState('all');
  const [userTypeFilter, setUserTypeFilter] = useState('all');
  const [timeFilter, setTimeFilter] = useState('weekly');
  const [outlets, setOutlets] = useState([]);
  const [loading, setLoading] = useState({
    totalData: true,
    graphData: true,
    outlets: true
  });

  const fetchGraphData = async () => {
    try {
      setLoading(prev => ({ ...prev, graphData: true }));
      let url = 'dashboard/getUsersDataStats';
      let params = [];
      if (outletFilter !== 'all') {
        params.push(`outletId=${outletFilter}`);
      }
      if (timeFilter === 'weekly') {
        params.push("weekly=true");
      } else if (timeFilter === 'monthly') {
        params.push("monthly=true");
      }
      if (params.length > 0) {
        url += `?${params.join('&')}`;
      }
      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response?.data?.data) {
        const data = response.data.data;
        // const barChartData = [
        //   {
        //     city: 'Total',
        //     appUsers: data.totalNumberOfAppUsers?.[0]?.count || 0,
        //     kioskUsers: data.totalNumberOfKioskUsers?.[0]?.count || 0,
        //     deletedUsers: data.totalNumberOfDeletedUsers?.[0]?.count || 0,
        //     repeatingUsers: data.totalRepeatingUsers?.[0]?.count || 0,
        //     referralUsers: data.totalReferredUsers?.[0]?.count || 0,
        //     usersWithoutOrders: data.totalUsersWithoutOrders?.[0]?.count || 0,
        //   },
        // ];

        // Helper function to sum all counts in an array
        const sumCounts = (arr) => {
          if (!arr || !Array.isArray(arr)) return 0;
          return arr.reduce((total, item) => total + (item?.count || 0), 0);
        };

        const barChartData = [
          {
            city: 'Total',
            appUsers: sumCounts(data.totalNumberOfAppUsers),
            kioskUsers: sumCounts(data.totalNumberOfKioskUsers),
            deletedUsers: sumCounts(data.totalNumberOfDeletedUsers),
            repeatingUsers: sumCounts(data.totalRepeatingUsers),
            referralUsers: sumCounts(data.totalReferredUsers),
            usersWithoutOrders: sumCounts(data.totalUsersWithoutOrders),
          },
        ];
        setCityWiseUsers(barChartData);

        const trendData = [
          {
            date: new Date().toLocaleDateString(),
            repeatingUsers: data.totalRepeatingUsers?.[0]?.count || 0,
          },
        ];
        setRepeatingUsersTrend(trendData);
      }
    } catch (error) {
      console.error('Error fetching graph data:', error);
    } finally {
      setLoading(prev => ({ ...prev, graphData: false }));
    }
  };

  const fetchTotalUsersKPIData = async () => {
    try {
      setLoading(prev => ({ ...prev, totalData: true }));
      const url = 'dashboard/getUsersDataStats';
      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response?.data?.data) {
        setTotalUsersData(response.data.data);
      }
    } catch (error) {
      console.error('Error fetching total users data:', error);
    } finally {
      setLoading(prev => ({ ...prev, totalData: false }));
    }
  };

  const getOutlets = async () => {
    try {
      setLoading(prev => ({ ...prev, outlets: true }));
      const headers = { Authorization: `Bearer ${token}` };
      const response = await axios.get('outlet', { headers });
      if (response?.data?.status === true) {
        setOutlets(response?.data?.data?.outlets);
      }
    } catch (error) {
      console.error('Error fetching outlets:', error);
    } finally {
      setLoading(prev => ({ ...prev, outlets: false }));
    }
  };

  useEffect(() => {
    fetchTotalUsersKPIData();
    getOutlets();
    fetchGraphData();
  }, []);

  useEffect(() => {
    fetchGraphData();
  }, [timeFilter, outletFilter]);

  return (
    <Container fluid className="py-4 shadow-sm" style={{ backgroundColor: 'white' }}>
      <h2 className="mb-4 fw-bold">USER ANALYTICS</h2>
      <hr />
      {/* Overall Users Data Section */}
      <Card className="mb-4 shadow-sm">
        <Card.Header as="h5" className="bg-primary text-white">
          Overall Users Data
        </Card.Header>
        <Card.Body>
          {loading.totalData ? (
            <div className="d-flex justify-content-center py-5">
              <Spinner animation="border" variant="primary" />
            </div>
          ) : (
            <Row className="g-4 justify-content-center">
              {/* Total App Users */}
              <Col md={3} sm={6}>
                <KpiCard
                  title="Total App Users"
                  value={totalUsersData?.totalNumberOfAppUsers?.[0]?.count || 0}
                  valueColor="#007bff"
                  icon="bi-phone"
                  backgroundColor="rgba(0, 123, 255, 0.1)"
                  loading={loading.totalData}
                />
              </Col>

              {/* Total Kiosk Users */}
              <Col md={3} sm={6}>
                <KpiCard
                  title="Total Kiosk Users"
                  value={totalUsersData?.totalNumberOfKioskUsers?.[0]?.count || 0}
                  valueColor="#28a745"
                  icon="bi-display"
                  backgroundColor="rgba(40, 167, 69, 0.1)"
                  loading={loading.totalData}
                />
              </Col>

              {/* Total Deleted Users */}
              <Col md={3} sm={6}>
                <KpiCard
                  title="Total Deleted Users"
                  value={totalUsersData?.totalNumberOfDeletedUsers?.[0]?.count || 0}
                  valueColor="#dc3545"
                  icon="bi-trash"
                  backgroundColor="rgba(220, 53, 69, 0.1)"
                  loading={loading.totalData}
                />
              </Col>

              {/* Total Referred Users */}
              <Col md={3} sm={6}>
                <KpiCard
                  title="Total Referred Users"
                  value={totalUsersData?.totalReferredUsers?.[0]?.count || 0}
                  valueColor="#6f42c1"
                  icon="bi-people"
                  backgroundColor="rgba(111, 66, 193, 0.1)"
                  loading={loading.totalData}
                />
              </Col>

              {/* Total Repeating Users */}
              <Col md={3} sm={6}>
                <KpiCard
                  title="Total Repeating Users"
                  value={totalUsersData?.totalRepeatingUsers?.[0]?.count || 0}
                  valueColor="#fd7e14"
                  icon="bi-arrow-repeat"
                  backgroundColor="rgba(253, 126, 20, 0.1)"
                  loading={loading.totalData}
                />
              </Col>

              {/* Total Users Without Orders */}
              <Col md={3} sm={6}>
                <KpiCard
                  title="Total Users Without Orders"
                  value={totalUsersData?.totalUsersWithoutOrders?.[0]?.count || 0}
                  valueColor="#17a2b8"
                  icon="bi-cart-x"
                  backgroundColor="rgba(23, 162, 184, 0.1)"
                  loading={loading.totalData}
                />
              </Col>
            </Row>
          )}
        </Card.Body>
      </Card>

      {/* Weekly/Monthly Users Data Section */}
      <Card className="shadow-sm">
        <Card.Header as="h5" className="bg-secondary text-white">
          {timeFilter === 'weekly' ? 'Weekly Users Data' : 'Monthly Users Data'}
        </Card.Header>
        <Card.Body>
          <Row className="mb-4">
            <Col md={4}>
              <Form.Group>
                <Form.Label>Outlet</Form.Label>
                  <Form.Select
                    value={outletFilter}
                    onChange={(e) => setOutletFilter(e.target.value)}
                  >
                    <option value="all">All</option>
                    {outlets
                      .filter((outlet) => outlet?.status === 'ACTIVE')
                      .map((outlet) => (
                        <option key={outlet?._id} value={outlet?._id}>
                          {outlet?.name}
                        </option>
                      ))}
                  </Form.Select>
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group>
                <Form.Label>Duration</Form.Label>
                <Form.Select
                  value={timeFilter}
                  onChange={(e) => setTimeFilter(e.target.value)}
                >
                  <option value="weekly">Weekly</option>
                  <option value="monthly">Monthly</option>
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <h5 className="mb-3">Users Type</h5>
              {loading.graphData ? (
                <div className="d-flex justify-content-center align-items-center" style={{ height: '300px' }}>
                  <Spinner animation="border" variant="secondary" />
                </div>
              ) : (
                <ResponsiveContainer width="100%" height={300}>
                  <BarChart data={cityWiseUsers}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="city" />
                    <YAxis />
                    <Tooltip />
                    <Legend wrapperStyle={{ marginLeft: 20 }} />
                    <Bar dataKey="appUsers" fill="#8884d8" name="App" />
                    <Bar dataKey="kioskUsers" fill="#82ca9d" name="Kiosk" />
                    <Bar dataKey="deletedUsers" fill="#ffc658" name="Deleted" />
                    <Bar dataKey="repeatingUsers" fill="#ff7300" name="Repeating" />
                    <Bar dataKey="referralUsers" fill="#d27300" name="Referred" />
                    <Bar dataKey="usersWithoutOrders" fill="#d62728" name="Without Orders" />
                  </BarChart>
                </ResponsiveContainer>
              )}
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default UsersKPI;